import { AddExternalAssetButton } from '@/ui/components/add-external-asset-button'
import DashboardPage from '@components/pages/dashboard'
import { useDomainsPage } from './hooks/useDomainsPage'
import DomainsTable from './components/domainsTable/domainsTable'
import DomainsHeader from './components/header/DomainsHeader'
import { TitleWrapper } from '@routes/digital-footprint/routes/assets/assets.styles'
import Typography from '@/ui/components/typography'
import { InlineScanIndicator } from '@/ui/components/inline-scan-indicator'
import { AssetsExport } from '@routes/digital-footprint/routes/assets/components/assetExport'
import { TableWrapper } from '@/ui/components/CustomTable/CustomTable.styles'
import AssetsSkeleton from '@routes/digital-footprint/routes/assets/components/skeleton'

const DomainsPage = () => {
    const { loading, filteredAssets, scanInProgress, emptyAssetsMessage } =
        useDomainsPage()

    return (
        <DashboardPage
            name="Domains"
            loading={loading}
            hideScanInProgress
            pageActions={
                <AddExternalAssetButton
                    label="Add Domains"
                    drawerContentType="addDomain"
                    analyticsEvent="SEM::user_clicks_at_add_domains"
                    testId="add-domains-button"
                />
            }
            skeleton={<AssetsSkeleton />}
        >
            <TableWrapper>
                <TitleWrapper>
                    <Typography variant="m-regular">Domains</Typography>
                    <AssetsExport
                        assets={filteredAssets}
                        exportScope="domains"
                        scanInProgress={!!scanInProgress}
                    />
                    <InlineScanIndicator scanInProgress={!!scanInProgress} />
                </TitleWrapper>
                <DomainsHeader />
                <DomainsTable
                    assets={filteredAssets}
                    emptyAssetsMessage={emptyAssetsMessage}
                />
            </TableWrapper>
        </DashboardPage>
    )
}

export default DomainsPage
